<template>
  <div>
    <AlbumHeader
      :loginStatus="loginStatus"
      :roleStatus="roleStatus"
      :data="albumInfo"
      :albumId="albumId"
      :documentId="documentId"
      @toLogin="toLogin"
      :previewIndex="previewIndex"
      @handleFeedbackDialogVisible="handleFeedbackDialogVisible"
      @showSetDialog="openSetDialog"
      @showErrorCodeStatus="showErrorCodeStatus"
      @handleDownLoad="handleDownLoad"
    />
    <!-- body -->
    <div class="album-preview-body">
      <div class="album-preview-body-content">
        <div
          class="resource-tab-info"
          v-if="
            albumInfo &&
            albumInfo.albumResourceDoList &&
            albumInfo.albumResourceDoList.length
          "
        >
          <div class="resource-tab-list" ref="resourceTabList">
            <div
              v-for="(item, index) in albumInfo.albumResourceDoList"
              :key="item.documentId"
              class="resource-tab-item"
              v-if="index <= 4"
              :class="{ active: index == previewIndex }"
              data-io-click="tracker"  @click="checkCurrentPreviewIndex(index)"
              @mouseenter="handleShowSubTitle(item, index, true)"
              @mouseleave="handleShowSubTitle(item, index, false)"
            >
              <div class="tab-center-item">
                <svg class="icon shangchuantupian" aria-hidden="true">
                  <use
                    :xlink:href="
                      '#icon-icon-' + item.fileType + '-filled-small'
                    "
                  ></use>
                </svg>
                {{ item.typeName }}
                <i
                  v-if="item.fileType == 'compress'"
                  class="iconfont icon-down-arrow"
                ></i>
              </div>
              <div
                class="sub-title-box"
                v-if="
                  item.previewInfo &&
                  item.previewInfo.isRar &&
                  item.showSubTitle
                "
              >
                <div
                  v-for="(childItem, childIndex) in item.previewInfo
                    .previewFileList"
                  :key="childIndex"
                  class="sub-title-item"
                  data-io-click="tracker"  @click.stop="
                    handleCheckCurrentPreview(item, childIndex, index)
                  "
                  :class="{
                    active: item.currentPreviewSoftIndex == childIndex,
                  }"
                >
                  <svg class="icon shangchuantupian" aria-hidden="true">
                    <use
                      :xlink:href="
                        '#icon-icon-' + childItem.fileType + '-filled-small'
                      "
                    ></use>
                  </svg>
                  <div class="sub-title-text">{{ childItem.softName }}</div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="document-title"
            :style="{
              maxWidth: `calc(100% - ${resourceTabListWidth}px - 40px)`,
            }"
          >
            {{ albumInfo.albumResourceDoList[previewIndex].title }}.{{
              albumInfo.albumResourceDoList[previewIndex].fileExt
            }}
          </div>
        </div>
        <div class="resource-preview-content">
          <div class="document-preview">
            <!-- 左侧导航 -->
            <div
              class="left-scroll-menu"
              v-if="
                currentFileExt != 'video' &&
                currentFileExt != 'audio' &&
                currentFileExt == 'ppt' &&
                currentPreviewSoft.contentList &&
                currentPreviewSoft.contentList.length
              "
            >
              <div
                v-for="(item, index) in currentPreviewSoft.contentList"
                :key="index"
                class="scroll-item"
                :class="{ active: index == currentIndex }"
                data-io-click="tracker"  @click="changeCurrentPage(index)"
                :data-index="index"
                v-lazy-container="{ selector: 'img' }"
                v-if="!loading"
              >
                <img
                  v-if="currentFileExt != 'html'"
                  @load="imageLoad"
                  :data-src="item.data"
                  alt=""
                />
                <span class="page-icon">{{ index + 1 }}</span>
              </div>
            </div>
            <div
              v-if="
                currentFileExt != 'video' &&
                currentFileExt != 'audio' &&
                currentPreviewSoft &&
                currentPreviewSoft.contentList
              "
              class="scroll-outer-wrapper"
              :class="{
                'no-content-wrapper':
                  !currentPreviewSoft ||
                  !currentPreviewSoft.contentList ||
                  !currentPreviewSoft.contentList.length,
              }"
              ref="softPreviewWrapper"
            >
              <ul
                class="scroll-wrapper"
                :class="[{ 'html-scroll-wrapper': currentFileExt == 'html' }]"
                ref="softWrapper"
              >
                <li
                  v-for="(item, index) in currentPreviewSoft.contentList"
                  :key="index"
                  v-if="!loading"
                  class="scroll-item"
                  :data-index="index"
                  v-lazy-container="{ selector: 'img' }"
                >
                  <img
                    ref="itemDoc"
                    v-if="currentFileExt != 'html'"
                    @load="imageLoad"
                    :data-src="item.data"
                    alt=""
                  />
                  <iframe
                    style="width: 100%; height: 100%"
                    v-else
                    allowfullscreen="true"
                    :src="item.data"
                  ></iframe>
                </li>
              </ul>
              <div
                v-if="
                  currentPreviewSoft &&
                  currentFileExt != 'video' &&
                  currentFileExt != 'audio' &&
                  currentFileExt != 'html' &&
                  currentPreviewSoft.contentList &&
                  currentPreviewSoft.contentList.length > 0 &&
                  !loginStatus
                "
                class="bottom-tools-nologin"
              >
                <div class="bottom-tips">
                  <img
                    style="height: 16px; width: 16px"
                    src="@/assets/images/suo.png"
                    alt=""
                  />
                  <span class="nologinTips"
                    >已查看{{
                      Math.floor(
                        parseFloat(
                          (
                            currentPreviewSoft.contentList.length /
                            (currentPreviewSoft.pageNum == null
                              ? 1
                              : currentPreviewSoft.pageNum)
                          ).toFixed(2) * 100
                        )
                      )
                    }}%，<button class="tologinButton" data-io-click="tracker"  @click="toLogin">
                      登录</button
                    >后获取完整内容</span
                  >
                </div>
              </div>
              <!--          非视频和非音频和非通享卡资料,登录无权限  且 不是全预览的资料   展示下面的提示-->
              <div
                v-if="loginNoAuthAndNotFullPreviewStatus"
                class="bottom-tools-nologin"
              >
                <div class="bottom-tips" style="width: 840px">
                  <img
                    style="height: 16px; width: 16px"
                    src="@/assets/images/suo.png"
                    alt=""
                  />
                  <!--              用户没有达到全预览上限，说明没有对应的权限-->
                  <span
                    v-if="
                      !this.isBeyondFullPreviewLimit ||
                      !this.albumInfo.albumResourceDoList[previewIndex]
                        .isAccessibleByUser
                    "
                    class="nologinTips"
                  >
                    预览已结束，开通<span
                      data-io-click="tracker"  @click="toLandPage"
                      style="
                        cursor: pointer;
                        text-decoration: underline;
                        color: #0057ff;
                      "
                      >AI阅读</span
                    >服务可享有完整版资料查看权限
                  </span>

                  <!--              用户达到全预览上限，但是 没有此资料权限-->
                  <span v-else class="nologinTips">
                    您已经达到资料每日全预览上限(150份/日)，请您明日再来
                  </span>
                </div>
              </div>

              <div
                v-if="
                  currentPreviewSoft &&
                  currentPreviewSoft.contentList &&
                  !currentPreviewSoft.contentList.length &&
                  !loading
                "
                class="default-style"
              >
                <!-- <img src="@/assets/images/no-preview.png" alt="" />
                <div>{{ getInvalidPreviewText }}</div> -->
                <NoContent :message="getInvalidPreviewText" />
              </div>
              <!--没有返回任何内容的情况下-->
              <div class="default-style" v-if="!currentFileExt && !loading">
                <div v-if="loginStatus">
                  <!-- <img src="@/assets/images/no-preview.png" alt="" />
                  <div>{{ getInvalidPreviewText }}</div> -->
                  <NoContent :message="getInvalidPreviewText" />
                </div>
                <div class="no-preview-cover" v-else>
                  <div class="tanchuang-content">
                    <img
                      style="height: 50px; width: 50px"
                      src="@/assets/images/suo2.png"
                      alt=""
                    />
                    <div class="font">暂不支持预览，登录后即可查看完整内容</div>
                    <button
                      data-io-click="tracker"  @click="toLogin"
                      style="
                        display: inline-flex;
                        height: 48px;
                        padding: 0px 48px;
                        justify-content: center;
                        align-items: center;
                        gap: 6px;
                        flex-shrink: 0;
                        border-radius: var(----xkw-card-radious, 8px);
                        background: linear-gradient(
                          90deg,
                          #eed4a3 0%,
                          #d8ab67 100%
                        );
                        margin-top: 20px;
                        font-size: 16px;
                        color: #734301;
                      "
                    >
                      登录/注册
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="
                (currentFileExt === 'video' || currentFileExt === 'audio') &&
                previewInfo
              "
              class="video-wrapper"
            >
              <AliPlayer
                ref="player"
                :mediaType="currentFileExt"
                :url="
                  previewInfo && !previewInfo?.isRar
                    ? previewInfo?.streamInfos &&
                      previewInfo?.streamInfos[0]?.playURL
                    : currentPreviewSoft?.playURL
                "
                :playList="currentPreviewSoft?.streamInfos"
                :mediaPoints="currentPreviewSoft?.mediaPoints"
                v-if="
                  (!previewInfo?.isRar
                    ? previewInfo?.streamInfos &&
                      previewInfo?.streamInfos[0]?.playURL
                    : currentPreviewSoft?.playURL) ||
                  (currentPreviewSoft?.mediaID && currentPreviewSoft?.playAuth)
                "
                :vid="currentPreviewSoft?.mediaID"
                :playauth="currentPreviewSoft?.playAuth"
                :poster="currentPreviewSoft?.coverURL"
                :loginStatus="loginStatus"
                :duration="currentPreviewSoft?.duration"
                @onPlayInfo="submitPlayInfo"
                @savePlayLog="savePlayLog"
                @playStart="handlePlayStart"
                @toLogin="toLogin"
                :loginPopupVisible="loginPopupVisible"
              />
              <div v-else class="default-style">
                <div v-if="loginStatus">
                  <img src="@/assets/images/no-preview.png" alt="" />
                  <div>无法预览</div>
                </div>
                <div class="no-preview-cover" v-else>
                  <div class="tanchuang-content">
                    <img
                      style="height: 50px; width: 50px"
                      src="@/assets/images/suo2.png"
                      alt=""
                    />
                    <div class="font">暂不支持预览，登录后即可查看完整内容</div>
                    <button
                      data-io-click="tracker"  @click="toLogin"
                      style="
                        display: inline-flex;
                        height: 48px;
                        padding: 0px 48px;
                        justify-content: center;
                        align-items: center;
                        gap: 6px;
                        flex-shrink: 0;
                        border-radius: var(----xkw-card-radious, 8px);
                        background: linear-gradient(
                          90deg,
                          #eed4a3 0%,
                          #d8ab67 100%
                        );
                        margin-top: 20px;
                        font-size: 16px;
                        color: #734301;
                      "
                    >
                      登录/注册
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="footer-occupy"></div> -->
        <AlbumFooter
          :loginStatus="loginStatus"
          :roleStatus="roleStatus"
          :data="albumInfo"
          :albumId="albumId"
          :documentId="documentId"
          @toLogin="toLogin"
          :previewIndex="previewIndex"
          @handleFeedbackDialogVisible="handleFeedbackDialogVisible"
          @showSetDialog="showSetDialog"
          size="large"
          @handleDownLoad="handleDownLoad"
          @showErrorCodeStatus="showErrorCodeStatus"
        />
      </div>
    </div>
    <LoginModal
      :loginPopupVisible="loginPopupVisible"
      @closeLoginPopupVisible="loginPopupVisible = false"
    />
    <div v-if="showSetDialog">
      <SetDialog v-on:closeSetDialog="closeSetDialog"></SetDialog>
    </div>
    <feedBackModal
      @closeModal="handleCloseModal"
      :documentInfo="albumInfo.albumResourceDoList[previewIndex]"
      v-if="feedbackDialogVisible"
      :feedbackDialogVisible="feedbackDialogVisible"
    ></feedBackModal>
    <DownLoadErrorDialog
      :visible="isShowDownloadErrorVisible"
      :message="downloadErrorMessage"
      :type="downloadErrorType"
      @handleShowDownloadErrorVisible="handleShowDownloadErrorVisible"
      @handleClose="handleShowDownloadErrorVisible(false)"
    >
    </DownLoadErrorDialog>
  </div>
</template>
<script>
import util from "@/assets/js/common/util";
import loginStatus from "@/assets/js/mixin/loginStatus";
import api from "@/assets/js/service/api";
import softUtil from "@/assets/js/service/softUtil";
import AliPlayer from "@/components/AliPlayer";
import DownLoadErrorDialog from "@/components/DownLoadErrorDialog.vue";
import feedBackModal from "@/components/feedBackModal";
import NoContent from "@/components/NoContent.vue";
import SetDialog from "@/pages/soft/tanchuang/setDialog.vue";
import { getAiReadAlbumInfo, savePlayLoglabDatakanban } from "@/utils/apis";
import request from "@/utils/request";
import AlbumFooter from "../components/AlbumFooter.vue";
import AlbumHeader from "../components/AlbumHeader.vue";
import LoginModal from "../components/LoginModal.vue";
export default {
  inject: ["textbook"],
  mixins: [loginStatus],
  data() {
    return {
      albumId: "",
      albumInfo: null,
      loginPopupVisible: false,
      isShowDownloadErrorVisible: false,
      downloadErrorMessage: "",
      downloadErrorType: 1,
      feedbackDialogVisible: false,
      previewIndex: 0,
      // 当前预览的资料
      currentPreviewSoft: null,
      currentPreviewSoftIndex: 0,
      // 预览信息
      previewInfo: null,
      currentFileExt: "",
      itemHeight: [],
      loading: false,
      // 滚动的距离
      scrolly: -1,
      // 当前滚动的索引
      currentIndex: 0,
      offsetTime: 0,
      documentId: null,
      showSetDialog: false,
      resourceTabListWidth: 0,
      loadingZipInfo: false,
      //资料预览是否超过了全预览限制
      isBeyondFullPreviewLimit: false,
    };
  },
  components: {
    AlbumHeader,
    AlbumFooter,
    DownLoadErrorDialog,
    LoginModal,
    AliPlayer,
    feedBackModal,
    SetDialog,
    NoContent,
  },
  watch: {
    scrolly(newy) {
      if (newy >= 0) this.currentIndex = 0;
      // console.log("newy", newy);
      let itemHeight = this.itemHeight;
      let length = itemHeight.length;
      for (let i = 0; i < length - 1; i++) {
        let h1 = itemHeight[i];
        let h2 = itemHeight[i + 1];
        if (newy >= h1 && newy < h2) {
          this.currentIndex = i;
          return;
        } else if (newy >= itemHeight[length - 1]) {
          this.currentIndex = length - 1;
          return;
        }
      }
    },
    currentPreviewSoft(newVal) {
      // console.log("----currentPreviewSoft", newVal);
    },
  },
  computed: {
    getInvalidPreviewText: function () {
      if (!this.currentPreviewSoft) return "";
      let { fileType, fileExt, extension } = this.currentPreviewSoft;
      let previewFileList =
        this.currentPreviewSoft?.previewInfo?.previewFileList || [];
      fileExt = !fileExt ? extension : fileExt;
      // const previewFileList = this.previewFileList || [];
      // 有效的文件
      const isInValidFile = !fileType || fileExt === "exe" || fileExt === "gz";
      if (isInValidFile) return "暂不支持预览";
      const isInvalidList =
        Array.isArray(previewFileList) && !previewFileList.length;
      const isValidArr = (arr) => Array.isArray(arr) && arr.length;
      const isInvalidContent =
        isValidArr(previewFileList) && !previewFileList[0].contentList.length;
      if (isInvalidList || isInvalidContent) {
        return "预览生产中，请稍后再试";
      }
      return "无法预览";
    },
    //非视频和音频资料,登录无权限  且 不是全预览的资料
    loginNoAuthAndNotFullPreviewStatus() {
      return (
        this.currentPreviewSoft &&
        this.currentFileExt != "video" &&
        this.currentFileExt != "audio" &&
        this.currentFileExt != "html" &&
        this.currentPreviewSoft.contentList &&
        this.currentPreviewSoft.contentList.length > 0 &&
        this.loginStatus &&
        this.currentPreviewSoft.pageNum &&
        this.currentPreviewSoft.previewCount &&
        this.currentPreviewSoft.pageNum > this.currentPreviewSoft.previewCount
      );
    },
  },
  mounted() {
    console.log(this.$route);
    this.previewIndex = this.$route?.query?.chooseIndex || 0;
    // 专辑id
    this.albumId = this.$route.params.pathMatch;
    this.getAiReadAlbumInfo();
    this.getUserLoginStatus();
  },
  methods: {
    openSetDialog: function () {
      // this.documentInfo = null;
      this.showSetDialog = true;
      this.$emit("showSetDialog", this.showSetDialog);
    },
    closeSetDialog: function () {
      this.showSetDialog = false;
      this.$emit("showSetDialog", this.showSetDialog);
    },
    showErrorCodeStatus(data) {
      console.log("data--", data);
      softUtil.handleErrorCodeStatus(data, this);
    },
    toLogin() {
      this.loginPopupVisible = true;
    },
    // 下载资料
    async handleDownLoad() {
      let fileIds = this.documentId || [];
      await softUtil.WriteDownScript(fileIds, this, false);
      console.log("下载资料");
    },
    async savePlayLog(e) {
      console.log("e", e);
      let { durationSeconds, playTime } = e;
      let { subjectFeatureType } = this.$route.query;
      let data = await savePlayLoglabDatakanban({
        durationSeconds,
        playTime,
        videoId:
          this.albumInfo.albumResourceDoList[this.previewIndex].documentId,
        experimentForm: subjectFeatureType,
      });
    },
    changeCurrentPage(index) {
      this.currentIndex = index;
      let softPreviewWrapper = this.$refs.softPreviewWrapper;
      softPreviewWrapper.scrollTop = this.itemHeight[index];
    },
    checkCurrentPreviewIndex(index) {
      // console.log("点击切换预览", index);
      this.previewIndex = index;
      let currentPreviewInfo =
        this.albumInfo.albumResourceDoList[this.previewIndex];
      let { fileType, previewInfo } = currentPreviewInfo;
      this.albumInfo.albumResourceDoList.forEach((item) => {
        if (item.fileType == "compress") {
          this.$set(item, "currentPreviewSoftIndex", null);
        }
      });
      if (currentPreviewInfo && currentPreviewInfo.fileType == "compress") {
        this.$set(currentPreviewInfo, "currentPreviewSoftIndex", 0);
      }
      if (currentPreviewInfo && !currentPreviewInfo.previewInfo) {
        // 获取预览信息
        this.getCurrentResourcePreview();
      } else {
        this.currentPreviewSoft =
          fileType === "video" || fileType === "audio"
            ? previewInfo
            : previewInfo.previewFileList[0];
        this.currentFileExt =
          fileType === "video" || fileType === "audio"
            ? fileType
            : previewInfo.previewFileList[0].fileType;
        this.previewInfo = currentPreviewInfo.previewInfo;
        this.documentId = currentPreviewInfo.documentId;
      }
    },
    handlePlayStart() {},
    handleCheckCurrentPreview(item, index, parentIndex) {
      if (item.currentPreviewSoftIndex != index) {
        this.isClickStatus = true;
        let softPreviewWrapper = this.$refs.softPreviewWrapper;
        let scrollTop = softPreviewWrapper.scrollTop;
        softPreviewWrapper && (softPreviewWrapper.scrollTop = 0);
        // document.body.scrollTop = document.documentElement.scrollTop = 0;
        this.$set(item, "currentPreviewSoftIndex", index);
        this.currentPreviewSoft = item.previewInfo.previewFileList[index];
        this.currentFileExt = this.currentPreviewSoft.fileType;
        this.showSubTitle = !this.showSubTitle;
        this.previewIndex = parentIndex;
        setTimeout(() => {
          this.isClickStatus = false;
        }, 10);
        if (this.currentFileExt != "video" && this.currentFileExt != "audio") {
          this.handleReInitScrollAndComputeSubTitle();
        } else {
          // 如果是视频的话处理视频 获取当前视频预览
          // 对于视频额外做处理：校本的视频放在一起了
          if (
            !this.currentPreviewSoft.coverURL ||
            !this.currentPreviewSoft.playURL
          ) {
            this.currentPreviewSoft.contentList &&
              this.currentPreviewSoft.contentList.length &&
              this.getCurrentVideoPreview();
          }
        }
      }
    },
    submitPlayInfo(r) {
      this.played_duration = r.played_duration; // 视频的播放时长
      this.player_show_duration = r.player_show_duration; // 播放器时长
      this.total_duration = this.previewInfo.duration; // 视频的总时长
      this.play_type = this.previewInfo.playType; // 视频类型
      this.played_progress = r.played_progress; // 播放进度
      if (this.played_duration > 0) {
        this.videoTracker = {
          $event_name: "video_play",
          resource_id: this.documentId, // 资料id
          played_duration: parseInt(this.played_duration), // 视频的播放时长
          played_progress: parseInt(this.played_progress), // 播放进度
          player_show_duration: parseInt(this.player_show_duration), // 获取播放器时长
          total_duration: this.previewInfo.duration, // 获取视频的总时长
          play_type: this.previewInfo.playType, // 视频类型
        };
        easyData.send(this.videoTracker);
        // 播放信息保存
      }
    },
    handleShowSubTitle(item, index, status) {
      if (item && item.fileType != "compress") {
        return;
      }
      if (item && !item.previewInfo && !this.loadingZipInfo) {
        this.getCurrentResourcePreview(index, false);
      }
      this.$set(item, "showSubTitle", status);
    },
    handleShowDownloadErrorVisible(e) {
      let { status, message } = e;
      this.downloadErrorMessage =
        typeof e == "boolean" ? this.downloadErrorMessage : message;
      this.isShowDownloadErrorVisible = typeof e == "boolean" ? e : status;
      let callback = () => {
        this.isShowDownloadErrorVisible = typeof e == "boolean" ? e : status;
      };
      this.textbook.noticeParentPageShowMask(
        status,
        callback,
        ".download-error-dialog"
      );
    },
    handleCloseModal() {
      this.handleFeedbackDialogVisible(false);
    },
    imageLoad() {
      this.handleReInitScrollAndComputeSubTitle();
    },
    handleReInitScrollAndComputeSubTitle() {
      let h = 0;
      this.itemHeight = [];
      this.imgHeight = [];
      this.$nextTick(() => {
        this._heightArr();
      });
    },
    _heightArr() {
      if (
        this.currentPreviewSoft.fileType != "video" &&
        this.currentPreviewSoft.fileType != "audio"
      ) {
        let h = 0;
        let list = this.$refs.itemDoc;
        let totalHeight = 0;
        list.forEach((item, i) => {
          this.itemHeight.push(totalHeight);
          totalHeight += item.offsetHeight;
        });
      }
    },
    handleFeedbackDialogVisible(status) {
      this.feedbackDialogVisible = status;
      let callback = () => {
        this.feedbackDialogVisible = status;
      };
      this.textbook.noticeParentPageShowMask(status, callback, ".feedback");
    },
    async getCurrentResourcePreview(index, isChoose = true) {
      //AI阅读，控制重复调取
      this.loadingZipInfo = true;
      isChoose && (this.loading = true);
      let previewIndex = index || this.previewIndex;
      let currentPreviewInfo = this.albumInfo.albumResourceDoList[previewIndex];
      this.documentId = currentPreviewInfo.documentId;
      let { fileType, documentId } = currentPreviewInfo;
      let requestApi = "";
      requestApi =
        fileType === "video" || fileType === "audio"
          ? api.document.videoPreview
          : api.document.preview;
      let previewInfo = await request.get(requestApi, {
        documentId,
      });
      this.previewInfo = previewInfo.result;
      //获取到 是否超过全预览限制 状态
      if (previewInfo.result) {
        this.isBeyondFullPreviewLimit =
          previewInfo.result.isBeyondFullPreviewLimit;
      }
      this.$set(currentPreviewInfo, "previewInfo", this.previewInfo);
      this.$set(currentPreviewInfo, "showSubTitle", true);
      const isVideoAudio = ["video", "audio"].includes(fileType);
      const isValidArr = (arr) => Array.isArray(arr) && arr.length;
      if (
        this.previewInfo &&
        (isVideoAudio ? true : isValidArr(this.previewInfo.previewFileList))
      ) {
        // 当前文件格式
        this.currentFileExt =
          fileType === "video" || fileType === "audio"
            ? fileType
            : this.previewInfo.previewFileList[0].fileType;
        // 当前预览资料
        isChoose &&
          (this.currentPreviewSoft =
            fileType === "video" || fileType === "audio"
              ? this.previewInfo
              : this.previewInfo.previewFileList[0]);
        this.previewInfo.previewFileList &&
          this.previewInfo.previewFileList.forEach((item) => {
            if (item.fileType == "video" || item.fileType == "audio") {
              this.$set(item, "playURL", "");
              this.$set(item, "coverURL", "");
            }
          });
        this.previewFileList = this.previewInfo.previewFileList || [];
        this.isRar = this.previewInfo.isRar;
        if (
          this.previewFileList.length > 0 &&
          this.previewFileList[0] &&
          isChoose &&
          (this.previewFileList[0].fileType == "video" ||
            this.previewFileList[0].fileType == "audio")
        ) {
          this.currentPreviewSoft.contentList &&
            this.currentPreviewSoft.contentList.length &&
            this.getCurrentVideoPreview();
        }
      }
      isChoose && (this.loading = false);
      this.$nextTick(() => {
        let softPreviewWrapper = this.$refs.softPreviewWrapper;
        softPreviewWrapper &&
          softPreviewWrapper.addEventListener(
            "scroll",
            this.scrollHandleDebounce,
            true
          );
      });
      // console.log('result',result)
      //AI阅读，控制重复调取  结束加载
      this.loadingZipInfo = false;
    },
    scrollHandleDebounce(e) {
      util.throttle(this.handleScroll, 500)(e);
    },
    handleScroll(e) {
      let softPreviewWrapper = this.$refs.softPreviewWrapper;
      let scrollTop = softPreviewWrapper.scrollTop;
      // let scrollTop = e.target.scrollTop;
      let clientHeight = softPreviewWrapper.clientHeight;
      let scrollHeight = softPreviewWrapper.scrollHeight;
      let mediaType = this.currentFileExt;
      if (this.isClickMenu || mediaType == "audio" || mediaType == "video")
        return;
      if (clientHeight + scrollTop >= scrollHeight) {
        // 滚动到底部
        this.currentIndex =
          this.currentPreviewSoft && this.currentPreviewSoft.contentList
            ? this.currentPreviewSoft.contentList.length - 1
            : 0;
      } else {
        this.scrolly = scrollTop;
      }
      // 上一次是否显示
      this.lastShowSubTitle = false;
    },
    // 获取当前视频预览
    getCurrentVideoPreview() {
      // 如果是视频类型 单独获取视频类型的资料地址
      let apiUrl = "";
      let param = {};
      apiUrl = api.document.compoundvideopreview;
      param = {
        mediaKey: this.currentPreviewSoft.contentList[0].data,
      };
      request.get(apiUrl, param).then((res) => {
        let currentPreviewSoft = this.currentPreviewSoft;
        currentPreviewSoft.playURL = res.result.playUrl;
        currentPreviewSoft.coverURL = res.result.coverUrl;
      });
    },
    async getAiReadAlbumInfo() {
      let data = await getAiReadAlbumInfo({
        albumId: this.albumId,
      });
      this.albumInfo = data.result;
      if (
        this.albumInfo.albumResourceDoList &&
        this.albumInfo.albumResourceDoList.length > 0
      ) {
        // 获取第一本资料预览
        this.getCurrentResourcePreview();
        this.albumInfo.albumResourceDoList.forEach((item, index) => {
          if (item.fileType == "compress") {
            this.$set(item, "showSubTitle", false);
            this.$set(item, "currentPreviewSoftIndex", !index ? 0 : null);
          }
        });
      }
      this.$nextTick(() => {
        let resourceTabList = this.$refs.resourceTabList;
        this.resourceTabListWidth = resourceTabList
          ? resourceTabList.offsetWidth
          : 0;
        // console.log('----resourceTabList',resourceTabList.offsetWidth)
      });
    },
    //前往对应服务的落地页
    toLandPage() {
      let url = "https://wxt.xkw.com/introduce/read.html";
      window.open(url);
    },
  },
};
</script>
<style lang="scss" scoped>
.album-preview-body {
  border-radius: 8px 8px 0 0;
  background-color: #eaeff2;
  position: relative;
  height: calc(100vh - 93px);
  .album-preview-body-content {
    padding: 20px 20px 66px 20px;
    height: 100%;
  }
  .resource-tab-info {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    .resource-tab-list {
      // justify-content: center;
      display: flex;
      align-items: center;
      .resource-tab-item {
        font-size: 14px;
        display: flex;
        align-items: center;
        height: 30px;
        line-height: 30px;
        padding: 0 32px;
        color: #1a1a1a;
        position: relative;
        z-index: 10;
        cursor: pointer;
        .tab-center-item {
          padding: 0 10px;
          background: rgba(255, 255, 255, 0.5);
          svg {
            font-size: 16px;
            margin-right: 4px;
          }
          i {
            display: inline-block;
            font-size: 12px;
            color: #7e7e7e;
            transform: scale(0.8);
            transition: 0.2s all;
          }
        }
        &:hover {
          .tab-center-item {
            color: #4494ff;
          }
          .tab-center-item {
            i {
              transform: rotate(180deg) scale(0.8);
              color: #4494ff;
            }
          }
        }
        &::after {
          position: absolute;
          display: block;
          content: "";
          left: 0;
          width: 32px;
          height: 30px;
          background: url("../../../assets/images/default-left-icon.png")
            no-repeat top center;
          background-size: 100% 100%;
        }
        &::before {
          position: absolute;
          display: block;
          content: "";
          right: 0;
          width: 32px;
          height: 30px;
          background: url("../../../assets/images/default-left-icon.png")
            no-repeat top center;
          background-size: 100% 100%;
          transform: rotateY(180deg);
        }
        &.active {
          z-index: 10;
          .tab-center-item {
            background: #fff;
          }
          &::after {
            background: url("../../../assets/images/active-left-icon.png")
              no-repeat top center;
            background-size: 100% 100%;
          }
          &::before {
            background: url("../../../assets/images/active-left-icon.png")
              no-repeat top center;
            background-size: 100% 100%;
          }
        }
        &:first-child {
          padding-left: 14px;
          &::after {
            width: 14px;
            // background: none;
            background: rgba(255, 255, 255, 0.5);
            border-radius: 8px 0 0 0;
          }
          &.active {
            &::after {
              background: #fff;
            }
          }
        }
        &:not(:first-child) {
          margin-left: -14px;
        }
        .sub-title-box {
          position: absolute;
          left: 14px;
          transform: translateY(50%);
          margin-top: 27px;
          max-width: 800px;
          padding: 12px 16px;
          border-radius: 4px;
          background: #fff;
          box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08),
            0px 2px 10px 0px rgba(0, 0, 0, 0.06),
            0px 4px 6px -2px rgba(0, 0, 0, 0.08);
          .sub-title-item {
            display: flex;
            align-items: center;
            svg {
              font-size: 16px;
              margin-right: 4px;
            }
            .sub-title-text {
              flex: 1;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            &:hover {
              color: #0057ff;
            }
            &.active {
              color: #0057ff;
            }
          }
        }
      }
    }
    .document-title {
      font-size: 14px;
      color: #7e7e7e;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .resource-preview-content {
    background: #fff;
    border-radius: 0 8px 0 0;
    width: 100%;
    height: calc(100% - 30px);
    overflow-y: scroll;
    &::-webkit-scrollbar {
      //设置滚动条宽高
      display: none;
    }
    .document-preview {
      padding: 32px 0 0 90px;
      width: 100%;
      background: #fff;
      // flex: 1;
      float: left;
      height: calc(100vh - 138px);
      // width: 72%;
      display: flex;
      .left-scroll-menu {
        width: 128px;
        margin-right: 16px;
        overflow-y: scroll;
        height: calc(100vh - 138px - 16px);
        .scroll-item {
          height: 72px;
          margin-bottom: 12px;
          border-radius: 6px;
          overflow: hidden;
          border: 1px solid #ccc;
          cursor: pointer;
          box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.2);
          position: relative;
          img {
            width: 100%;
            // height: 100%;
          }
          .page-icon {
            position: absolute;
            bottom: 0;
            right: 0;
            z-index: 100;
            height: 15px;
            line-height: 15px;
            font-size: 12px;
            color: #fff;
            padding: 0 7px;
            background: rgba(0, 0, 0, 0.6);
            border-radius: 4px 0 6px 0;
          }
          &.active {
            border: 1px solid #0057ff;
          }
        }
        .continue-read {
          width: 128px;
          height: 40px;
          border-radius: 6px;
          font-size: 16px;
          line-height: 40px;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #0069ff;
          border: 1px solid #0069ff;
          i {
            margin-left: 6px;
            font-size: 12px;
            transform: scale(0.8);
          }
        }
        &::-webkit-scrollbar {
          //设置滚动条宽高
          display: none;
        }
      }
      &.full-preview {
        width: calc(100% - 32px);
      }

      &.video-preview {
        padding: 0;
        background: transparent;
      }

      .scroll-outer-wrapper {
        flex: 1;
        overflow-y: scroll;
        position: relative;
        padding-right: 90px;
        &::-webkit-scrollbar {
          width: 3px; /* 修改宽度 */
          height: 25px;
        }
        /* 修改滚动条轨道背景色 */
        &::-webkit-scrollbar-track {
          background-color: transparent;
        }
        /* 修改滚动条滑块颜色 */
        &::-webkit-scrollbar-thumb {
          background: rgba(0, 0, 0, 0.3);
          border-radius: 100px;
        }
        .scroll-wrapper {
          // padding-top: 40px;
          text-align: center;

          li {
            border-bottom: 1px solid #ddd;

            img {
              width: 100%;
            }

            &:last-child {
              border-bottom: 0px;
            }
          }

          &.html-scroll-wrapper {
            padding-top: 0px;
            height: calc(100vh - 86px);
            width: 100%;
            position: relative;
            transition: all 0.2s;
            &.is-full-page {
              position: fixed;
              top: 0;
              left: 0;
              width: 100vw;
              height: 100vh;
              z-index: 2000;
              transition: all 0.2s;
            }
            .scroll-item {
              height: 100%;
            }
            .full-page-btn {
              position: absolute;
              // width: 200px;
              height: 44px;

              border-radius: 10px;
              // background: rgba(255, 255, 255, 0.1);
              background: #1c1e1f;
              box-shadow: 0px 4px 6px -2px rgba(0, 0, 0, 0.08),
                0px 2px 10px 0px rgba(0, 0, 0, 0.06),
                0px 2px 8px 0px rgba(0, 0, 0, 0.08);
              padding: 10px 16px;
              top: 20px;
              right: 20px;
              z-index: 10;
              // transform: translate(-50%, -50%);
              cursor: pointer;
              div {
                width: 100%;
                height: 100%;
                line-height: 24px;
                // border-radius: 56px;
                // background: rgba(255, 255, 255, 0.2);
                font-size: 16px;
                text-align: center;
                color: #fff;
              }
              &:hover {
                div {
                  color: rgba(255, 255, 255, 0.7);
                }
              }
            }
            .cancel-full-page-btn {
              cursor: pointer;
              opacity: 0;
              left: 50%;
              transform: translateX(-50%);
              position: absolute;
              top: 11px;
              border-radius: 8px;
              background: rgba(0, 0, 0, 0.6);
              padding: 0 20px;
              height: 46px;
              line-height: 46px;
              color: #fff;
              font-size: 14px;
              display: flex;
              align-items: center;
              animation-name: fadenum;
              animation-duration: 3s;
              span {
                color: #ff9a18;
                display: block;
                border-radius: 4px;
                border: 1px solid #ff9a18;
                width: 44px;
                height: 30px;
                line-height: 30px;
                text-align: center;
                margin: 0 8px;
              }
            }
          }
        }
        // &::-webkit-scrollbar {
        //   //设置滚动条宽高
        //   display: none;
        // }
        &.no-content-wrapper {
          .scroll-wrapper {
            padding-top: 0px;
          }
        }

        .bottom-tools {
          position: fixed;
          left: calc((100% - 232px - 360px) / 2 + 232px);
          margin-left: -103px;
          width: 206px;
          bottom: 20px;
          height: 48px;
          background: rgba(0, 0, 0, 0.8);
          border-radius: 24px;
          // opacity: 0.8;
          font-size: 14px;
          color: #fff;
          text-align: center;
          align-items: center;
          justify-content: center;
          // justify-content: flex-start;
          line-height: 48px;
          display: flex;
          // padding-left: 29px;
          padding: 0 30px;

          &.full-preview-bottom-tools {
            left: calc((100% - 232px) / 2 + 232px);
          }

          .icon-item {
            display: flex;
            align-items: center;
            cursor: pointer;

            .icon-quanping1 {
              font-size: 24px;
            }

            .page-num {
              padding: 0 3px;
            }

            .icon-box {
              width: 24px;
              height: 24px;
              line-height: 1;
              display: inline-block;
              border-radius: 4px;
              cursor: pointer;
              display: flex;
              align-items: center;
              justify-content: center;

              &:hover {
                background: rgba(255, 255, 255, 0.4);
                // border-radius: 4px;
                // opacity: 0.4;
              }

              i {
                color: #fff;
                display: inline-block;
                font-size: 14px;
              }

              &.right-icon {
                i {
                  transform: rotate(180deg);
                }
              }
            }
          }

          .line {
            margin: 0 20px;
            width: 1px;
            height: 12px;
            background: #acacac;
          }
        }

        .loading-img {
          position: relative;
          top: 20%;

          img {
            width: 100%;
            height: 100%;
          }

          p {
            position: relative;
            margin-top: -20%;
            text-align: center;
            font-size: 14px;
            color: #ccc;
          }
        }
      }
      .video-wrapper {
        // min-height: calc(100vh - 86px);
        width: 100%;
        height: calc(100vh - 138px - 32px);
        // height: calc((72vw - 120px) * 9 / 16);
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        border-radius: 8px;
        overflow: hidden;
        ::v-deep .prism-player {
          height: 100% !important;
        }
      }
    }
  }
}
.default-style {
  text-align: center;
  // height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transform: translate(0);
  min-height: calc(100vh - 86px);

  img {
    width: 232px;
    height: 127px;
  }

  div {
    // margin-top: -50px;
    line-height: 1;
    color: #80848b;
    font-size: 16px;
  }
}
.no-preview-cover {
  width: 100vw;
  height: 100vh;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.7);
  z-index: 3001;
  position: relative;

  .tanchuang-content {
    height: 300px;
    width: 300px;
    margin: auto;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    position: absolute;
    text-align: center;
  }

  .font {
    color: #fff;

    /* Medium/--xkw-title-medium */
    font-family: "PingFang SC";
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 150% */
    margin-top: 20px;
  }
}
.footer-occupy {
  height: 90px;
}

.bottom-tools-nologin {
  width: 100%;
  height: 269px;
  -webkit-flex-shrink: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  background: -webkit-linear-gradient(
    top,
    rgba(255, 255, 255, 0) 50.19%,
    #fff 92.28%
  );
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 50.19%,
    #fff 92.28%
  );
  text-align: center;
  padding-top: 100px;
}
.bottom-tips {
  text-align: center;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  height: 24px;
  width: 725px;
}

.bottom-tips:before {
  width: 176px;
  height: var(----xkw-tag-radious, 2px);
  border-radius: var(----xkw-tag-radious, 2px);
  background: linear-gradient(
    270deg,
    #f1e0bf 0.29%,
    rgba(241, 224, 191, 0) 100%
  );
  content: "";
}
.bottom-tips:after {
  width: 176px;
  height: var(----xkw-tag-radious, 2px);
  border-radius: var(----xkw-tag-radious, 2px);
  background: linear-gradient(
    90deg,
    #f1e0bf 0.29%,
    rgba(241, 224, 191, 0) 100%
  );
  content: "";
}

.nologinTips {
  color: #666;
  text-align: center;

  /* regular/--xkw-title-regular */
  font-family: "PingFang SC";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
}
.tologinButton {
  color: #0057ff;
  text-align: center;
  cursor: pointer;

  /* regular/--xkw-title-regular */
  font-family: "PingFang SC";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
}
</style>
